export default __webpack_public_path__ + "static/media/storyone.762cb979.mp4";